/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTemplate } from '../../../../../../features/template/TemplateProvider';
import { ButtonPrimary } from '../../../../../../utils/Button';
import cn from '../../../../../../utils/cn';
import { GetDate } from '../../../../../../utils/Show';
import { DownArrowIcon } from '../../../../../../utils/SVGIcon';
import { TextCapitalize } from '../../../../../../utils/TextFormatter';
import { useAgencyInfo } from '../../../../AgencyInfoProvider';
import ModalAgencyCustomerStatusChange from '../../../../List/Modals/ModalAgencyCustomerStatusChange';

function TableInfoCard({ name, value, isCapitalize, className }) {
    return (
        <div
            className={cn(
                'text-sm text-primary-700 font-medium flex flex-row gap-3 justify-start items-center h-5',
                className
            )}
        >
            <p className="inline-flex justify-between items-center min-w-[112px] w-28">
                <span>{name}</span>
                <span>:</span>
            </p>
            <span
                className={cn(`value-text line-clamp-1 text-primary font-normal text-sm`, {
                    capitalize: isCapitalize
                })}
            >
                {value}
            </span>
        </div>
    );
}

function TableRow({ item }) {
    const [isActive, setIsActive] = useState(false);
    const { openModal, setConfirm } = useTemplate();
    const { handleReload } = useAgencyInfo();

    // -- Change Customer Status Handler
    const handleAgencyStatusModal = (e, data) => {
        e.stopPropagation();
        setConfirm({
            showButton: false,
            text: <ModalAgencyCustomerStatusChange data={data} onReload={handleReload} />
        });
    };

    return (
        <div
            tabIndex={-1}
            role="button"
            onClick={() => setIsActive(!isActive)}
            className={cn(
                `table-visible-data overflow-hidden w-full flex flex-col justify-between text-primary p-2.5 rounded-md transition-all duration-[800ms] ease-in-out remove-highlight`,
                {
                    'max-h-84': isActive,
                    'max-h-10': !isActive,
                    'placeholder-mode': item?.demo
                }
            )}
        >
            <div className="w-full flex flex-row gap-1 justify-between text-primary text-sm font-medium leading-normal">
                <div className="min-w-[112px] w-28 flex items-center gap-1">
                    <button
                        type="button"
                        className={cn(`-rotate-90 transition-all duration-200`, {
                            'rotate-0': isActive
                        })}
                    >
                        <DownArrowIcon />
                    </button>
                    <span>{item?.id}</span>
                </div>
                <div className="w-full">
                    <span className="line-clamp-1">{item?.organization}</span>
                </div>
                <div className="w-full hidden sm:block">
                    <span
                        className={`line-clamp-1 capitalize ${
                            item?.status === 'active' ? 'text-success' : 'text-warning'
                        }`}
                    >
                        {item?.status}
                    </span>
                </div>
            </div>

            <div className="table-data-more mt-3.5 flex flex-col justify-start items-item gap-2">
                <TableInfoCard
                    name="Organization"
                    value={
                        item.organization ? (
                            <Link
                                to={`${item?.id}/info`}
                                className="text-primary-700 underline font-medium"
                            >
                                {item.organization}
                            </Link>
                        ) : (
                            '--'
                        )
                    }
                />
                <TableInfoCard name="Role" value={TextCapitalize(item?.role)} />
                <TableInfoCard name="Email" value={item?.primaryEmail} />
                <TableInfoCard
                    name="Date Created"
                    value={GetDate(item?.timeCreated)}
                    isCapitalize
                />
                <TableInfoCard name="Currency" value={item?.currency} isCapitalize />
                {/* <TableInfoCard
                    name="2FA"
                    className={`[&>.value-text]:${item?.tfaEnabled ? 'text-secondary' : 'text-error'}`}
                    value={item?.tfaEnabled ? 'Enabled' : 'Disabled'}
                /> */}
                <TableInfoCard
                    name="Status"
                    value={item?.status}
                    isCapitalize
                    className={`sm:hidden ${item?.status === 'active' ? '[&>.value-text]:text-success' : '[&>.value-text]:text-warning'}`}
                />
                <div className="flex flex-wrap items-center justify-end gap-2 mt-2">
                    {item?.agencyId === -9191 ? (
                        <ButtonPrimary
                            btnType="button"
                            title="Move to Under Agency"
                            onClick={() => openModal('move-to-under-agency', item)}
                            className="h-7 text-sm text-nowrap whitespace-nowrap"
                        />
                    ) : null}
                    <ButtonPrimary
                        btnType="button"
                        title={item.status === 'active' ? 'Make Inactive' : 'Make Active'}
                        onClick={(ev) =>
                            handleAgencyStatusModal(ev, {
                                id: item?.id,
                                status: item?.status
                            })
                        }
                        className="h-7 text-sm text-nowrap whitespace-nowrap"
                    />
                    {item.status === 'active' && (
                        <ButtonPrimary
                            btnType="button"
                            title=" Change Currency"
                            onClick={() => openModal('CHANGE_CUSTOMER_CURRENCY_MODEL', item)}
                            // onClick={() => openModal('change-customer-currency-model', item)}
                            className="h-7 text-sm text-nowrap whitespace-nowrap"
                        />
                    )}
                </div>
            </div>
        </div>
    );
}

function TableMobile({ data }) {
    return (
        <div className="invoice_list_page_table">
            <div className="table-data [&>*:nth-child(odd)]:bg-primary-50">
                {data && data?.customers?.length === 0 ? (
                    <div className="w-full text-sm font-medium p-2 rounded-5">No Data Found</div>
                ) : (
                    data?.customers?.map((item) => <TableRow key={item.id} item={item} />)
                )}
            </div>
        </div>
    );
}

export default TableMobile;
